import * as d3 from 'd3';
import React from 'react';
import styled from 'styled-components';

import useCommonContext from './hooks/useCommonContext';

const StyledDiv = styled.div`
  position: absolute;
  ${props => props.theme.transition('transform', '100ms')};
  z-index: 1000;
`;

const InnerTooltip = styled.div`
  width: ${props => props.width};
  height: ${props => props.height};
  background: white;
  ${props => props.theme.shadow(0.14)};
  position: relative;
  left: -50%;
  top: ${props => props.top};
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  padding: 14px;
  pointer-events: none;
  z-index: 1000;
`;

const dateFormat = d3.timeFormat('%m/%d');
const numFormat = d3.format(',');

const DefaultDateHeader = styled.div`
  color: ${props => props.theme.enigmaBlue};
  font-size: 16px;
  font-weight: 500;
  margin: auto;
`;
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: center;
  font-size: 14px;
`;
const Stat = styled.div`
  margin: auto;
`;

const DefaultTooltip = tooltip => {
  return (
    <Wrapper>
      <DefaultDateHeader>{dateFormat(tooltip.xValue)}</DefaultDateHeader>
      <Stat>Value: {numFormat(tooltip.yValue)}</Stat>
    </Wrapper>
  );
};

const Component = props => {
  const { tooltip } = useCommonContext();

  // @colby.ing - This is hacky - until we use something like react-measure
  // to grab the dimensions of the actual generated tooltip,
  // We'll have to pass in the dimensions manually to position the
  // tooltip in the correct spot
  const { customTooltip } = props;
  const tooltipWidth = customTooltip ? props.tooltipWidth : 140;
  const tooltipHeight = customTooltip ? props.tooltipHeight : 60;

  return tooltip.xPos ? (
    <StyledDiv
      style={{
        transform: `translate(${tooltip.xPos}px, ${tooltip.yPos}px)`,
      }}
    >
      <InnerTooltip
        x={0}
        y={0}
        dy={-20}
        textAnchor='middle'
        height={`${tooltipHeight}px`}
        width={`${tooltipWidth}px`}
        top={`${tooltipHeight * -1 - 5}px`}
      >
        {customTooltip && customTooltip(tooltip)}
        {!props.customTooltip && DefaultTooltip(tooltip)}
      </InnerTooltip>
    </StyledDiv>
  ) : (
    <div />
  );
};

export default Component;
